module.exports = __webpack_public_path__ + "static/assets/32e0021542e34f09a747322d11868f23.mp3";